import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from './BrowserHistory';
import { PersistGate } from 'redux-persist/integration/react';
import { pdfjs } from 'react-pdf';

import { GlobalWorkerOptions as OriginalGlobalWorkerOptions } from 'pdfjs-dist';
import './shared/shim/react-pdf/Page/TextLayer.css';
import './shared/shim/react-pdf/Page/AnnotationLayer.css';
import './shared/shim/react-pdf/Page/XFALayer.css';
// const root = ReactDOM.createRoot(
//     document.getElementById('root') as HTMLElement
// );

// root.render(
import App from './App';
import reportWebVitals from './reportWebVitals';
import store, { persistor, history } from './state/RootReducer';

const { GlobalWorkerOptions } = pdfjs;

GlobalWorkerOptions.workerSrc = '/js/pdf.worker.min.mjs';

OriginalGlobalWorkerOptions.workerSrc = '/js/pdf.worker.min.mjs';

// const worker = new Worker(workerSrc, { type: 'module' });

// worker.addEventListener('error', (event) => {
//     rollbar.captureEvent(event, 'error');
// });
// worker.addEventListener('messageerror', (event) => {
//     rollbar.captureEvent(event, 'error');
// });

export const RootApp = (
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            <BrowserRouter history={history}>
                <App />
            </BrowserRouter>
        </PersistGate>
    </Provider>
);
ReactDOM.render(RootApp, document.getElementById('root'));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
